import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { CartProvider } from './contexts/CartContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import AppRoutes from './config/routes';
import { setTokenGetter } from './config/axios';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function AppContent() {
  const { getToken, isLoaded, isSignedIn } = useAuth();

  // Set the token getter for axios interceptor
  useEffect(() => {
    if (isLoaded) {
      // Wrap getToken to handle the case when user is not signed in
      const tokenGetter = async () => {
        if (!isSignedIn) {
          // console.log('User not signed in, no token available');
          return null;
        }
        try {
          const token = await getToken();
          // console.log('Token retrieved:', token ? 'Yes' : 'No');
          return token;
        } catch (error) {
          //console.error('Error getting token:', error);
          return null;
        }
      };
      setTokenGetter(tokenGetter);
    }
  }, [getToken, isLoaded, isSignedIn]);

  return (
    <CartProvider>
      <BrowserRouter>
        <LanguageProvider>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navigation />
            <main style={{ flex: 1 }}>
              <AppRoutes />
            </main>
            <Footer />
          </div>
        </LanguageProvider>
      </BrowserRouter>
    </CartProvider>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
    </QueryClientProvider>
  );
}

export default App;
